import React from 'react';
import { ParameterOption } from '@shared/types';

interface ColorSwatchPickerProps {
  value: string;
  options: ParameterOption[];
  onChange: (color: string) => void;
}

/**
 * Renders a row of filled color circle swatches for a color parameter
 * that has a limited set of allowed colors defined via bracket syntax, e.g.:
 *   case_color = "#999999"; // [#666666, #999999, #CCCCCC]
 */
export function ColorSwatchPicker({
  value,
  options,
  onChange,
}: ColorSwatchPickerProps) {
  const normalizedValue = value.toUpperCase();

  return (
    <div className="flex flex-wrap items-center gap-3">
      {options.map((opt) => {
        const hex = String(opt.value).toUpperCase();
        const isSelected = normalizedValue === hex;
        return (
          <button
            key={hex}
            aria-label={`Select color ${hex}`}
            onClick={() => onChange(String(opt.value))}
            className={`h-5 w-5 flex-shrink-0 rounded-full shadow-sm ring-offset-background transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 [@media(hover:hover)]:hover:scale-110 ${
              isSelected ? 'scale-110 ring-2 ring-ring ring-offset-2' : ''
            }`}
            style={{ backgroundColor: hex }}
          />
        );
      })}
    </div>
  );
}
